import React from 'react'
import { MainHeroHeadingH1, DescriptionDisplay1 } from './Typography'
import styled from 'styled-components'
import { breakpoint } from '@configs/utilities'

const PageHeaderFlexible = ({ maxWidthTitle, maxWidthDescription, titleIcon, title, description }) => {
  return (
    <Wrapper>
      <HeadingWrapper maxWidthTitle={maxWidthTitle}>
        {titleIcon ? (
          <IconWrapper>
            <img src={titleIcon} alt="title icon" />
          </IconWrapper>
        ) : null}

        <MainHeroHeadingH1>{title}</MainHeroHeadingH1>
      </HeadingWrapper>
      <DescriptionWrapper maxWidthDescription={maxWidthDescription}>
        <DescriptionDisplay1>{description}</DescriptionDisplay1>
      </DescriptionWrapper>
    </Wrapper>
  )
}

export default PageHeaderFlexible

const Wrapper = styled.div`
  width: 100%;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  text-align: center;
  padding: 0 20px;
  row-gap: 20px;

  @media screen and (min-width: ${breakpoint.xl}) {
    row-gap: 30px;
  }
`

const HeadingWrapper = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  max-width: ${(props) => (props.maxWidthTitle ? props.maxWidthTitle : '800px')};

  @media screen and (min-width: ${breakpoint.xxl}) {
    flex-direction: row;
  }
`

const IconWrapper = styled.span`
  width: 80px;
  display: flex;
  justify-content: center;
  align-items: center;
  margin: 0 0 15px;

  @media screen and (min-width: ${breakpoint.md}) {
    margin: 0 15px 0 0;
  }
`

const DescriptionWrapper = styled.div`
  max-width: ${(props) => (props.maxWidthDescription ? props.maxWidthDescription : '800px')};
`
